export default __webpack_public_path__ + "static/media/the-tall-trees-munnar.7d94754f.jpg";